<template>
  <div class="login-container">
    <div class="background-layer"></div>

    <div class="login-form-container">
      <div class="form-card">
        <div class="lang-switch">
          <button
            @click="switchLang('en-US')"
            :class="{ active: $i18n.locale === 'en-US' }"
          >
            English
          </button>
          <button
            @click="switchLang('zh-CN')"
            :class="{ active: $i18n.locale === 'zh-CN' }"
          >
            CN
          </button>
        </div>

        <br />
        <h2 class="sysTitle">SmartGo</h2>
        <br />
        <p class="introduction">{{ $t("SigninwithyourSmartGoAccount") }}</p>
        <br />

        <form @submit.prevent="handleLogin">
          <div class="input-group">
            <label for="username">{{ $t("Email") }}</label>
            <Input
              type="text"
              id="username"
              v-model="username"
              :placeholder="$t('Required')"
              size="large"
            />
            <div v-if="emailError" class="error-text">
              {{ $t("EnteryourEmail") }}
            </div>
          </div>

          <div class="input-group">
            <label for="password">{{ $t("password") }}</label>
            <Input
              id="password"
              v-model="password"
              type="password"
              password
              :placeholder="this.$t('EnterPassword')"
              size="large"
            />
            <div v-if="passwordError" class="error-text">
              {{ $t("Enteryourpassword") }}
            </div>
          </div>

          <div class="form-group">
            <input type="checkbox" id="RememberMe" v-model="rememberMe" />
            <label for="RememberMe">&nbsp;&nbsp;{{ $t("RememberMe") }}</label>
            <span class="float-right">
              <p>
                <a>{{ $t("Forgotyourpassword") }}?</a>
              </p>
            </span>
          </div>

          <button type="submit" class="login-btn" :disabled="isLoading">
            <span v-if="!isLoading">{{ $t("Signin") }}</span>
            <span v-else>{{ $t("Signin") }}...</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<!-- 当前登录组件只处理界面和事件， -->
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      username: "",
      password: "",
      isLoading: false,
      emailError: false,
      passwordError: false,
      rememberMe: false,
    };
  },

  mounted() {
    // 当页面加载时，检查是否有记住的账号和密码
    const savedUsername = localStorage.getItem("username");
    const savedPassword = localStorage.getItem("password");
    if (savedUsername && savedPassword) {
      this.username = savedUsername;
      this.password = savedPassword;
      this.rememberMe = true;
    }

    // 加载保存的语言设置（优先本地存储，默认英文）
    const savedLang = localStorage.getItem("locale") || "en-US";
    // 初始化语言（默认英文）
    this.$i18n.locale = savedLang;
  },

  methods: {
    ...mapActions("user", ["login"]),
    async handleLogin() {
      this.emailError = !this.username.trim();
      this.passwordError = !this.password.trim();
      if (this.emailError || this.passwordError) return;

      this.isLoading = true;
      try {
        await this.login({
          username: this.username,
          password: this.password,
          remember: this.rememberMe,
        });

        // ✅ 路由跳转可能已经发生，组件可能被销毁
        if (this._isDestroyed || this._isBeingDestroyed) return;

        this.$notice.success(this.$t("LoginSuccessful"));
      } catch (err) {
        // 同样加保护，避免销毁后仍访问实例
        if (!(this._isDestroyed || this._isBeingDestroyed)) {
          this.$notice.error(this.$t("LoginFailed"));
        }
      } finally {
        // 组件销毁时也不要再改本地 state
        if (!(this._isDestroyed || this._isBeingDestroyed)) {
          this.isLoading = false;
        }
      }
    },

    // 语言切换方法
    switchLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang); // 保存语言偏好
      // 同步iView组件语言（如果使用）
      if (window.iview) {
        window.iview.i18n((key, value) => this.$t(key, value));
      }
    },
  },
};
</script>

